export default function AfterExcitationVisual() {
  return <div>after excitation works</div>;
}